// Mirrors the backend `ImpersonationView` (the `current_view` JWT claim) of a superuser supporting a user
export const IMPERSONATION_VIEW = {
  ADMIN: 'admin',
  SUPPORTED_USER: 'supported_user',
} as const;

export type ImpersonationViewType = (typeof IMPERSONATION_VIEW)[keyof typeof IMPERSONATION_VIEW];
